import React, { useCallback } from "react";
import { IMutator } from "sonobello.utilities.react";

import IMedicalFormInterpreter from "../Types/IMedicalFormInterpreter";
import MedicalFormState from "../Types/MedicalFormState";

export interface IMedicalStep extends IMutator<boolean> {
  /** The medical form which fires mutation events when the medical questions are interacted with. */
  MedicalForm: React.FC<IMutator<MedicalFormState>>;
  /** The interpreter which transforms the medical form output into a non-candidate status decision. */
  medicalFormInterpreter: IMedicalFormInterpreter;
}

/** The medical step which takes a medical form's result and dispatches the aggregated qualification when it changes. */
const ComposableMedicalStep: React.FC<IMedicalStep> = ({ MedicalForm, medicalFormInterpreter, onChange }) => {
  const onMedicalFormChange = useCallback(
    (state: MedicalFormState) => {
      const isMedicallyDisqualified = medicalFormInterpreter.isNonCandidate(state);
      onChange(!isMedicallyDisqualified);
    },
    [onChange]
  );
  return <MedicalForm onChange={onMedicalFormChange} />;
};

export default ComposableMedicalStep;
